/* Pre-order app (Fortescue) cart guard.

   The app tags cart buttons with `preOrderCheckout` and binds
   `$(document).on('click', '.preOrderCheckout')` to run its cart check and
   send the shopper to checkout. On this theme it tags every button in the
   cart form, so pressing +, - or remove on a cart line went straight to
   checkout. The class is kept only on the real checkout button; any other
   button in the cart page or cart drawer has it removed as soon as it
   appears, including after the cart re-renders. */
(function () {
  var CLASS_NAME = 'preOrderCheckout';
  var CART_SCOPE = 'form[action*="/cart"], cart-items-component, cart-drawer-component, .cart-drawer, .cart-page';

  function isCheckout(el) {
    return el.getAttribute('name') === 'checkout' || el.id === 'checkout' || el.classList.contains('cart__checkout-button');
  }

  function release(el) {
    if (el.classList.contains(CLASS_NAME) && !isCheckout(el) && el.closest(CART_SCOPE)) {
      el.classList.remove(CLASS_NAME);
    }
  }

  function sweep(root) {
    if (!root.querySelectorAll) return;
    if (root.classList && root.classList.contains(CLASS_NAME)) release(root);
    root.querySelectorAll('.' + CLASS_NAME).forEach(release);
  }

  sweep(document);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        release(mutation.target);
      } else {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) sweep(node);
        });
      }
    });
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();
